export const PAGE_LOADING_EVENT = 'is-page-loading';

export const PageLoadableMixin = {
  methods: {
    startLoadingPage: function() {
      this.$wait.start(PAGE_LOADING_EVENT);
    },

    endLoadingPage: function() {
      this.$wait.end(PAGE_LOADING_EVENT);
    }
  }
};
